import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useTeamEquipmentTotal = (teamId: string | undefined) => {
  return useQuery({
    queryKey: ['team-equipment-total', teamId],
    // @ts-ignore - Avoiding deep type instantiation issue
    queryFn: async () => {
      if (!teamId) return 0;

      try {
        // @ts-ignore
        const equipmentResult = await supabase
          .from('team_equipment')
          .select('equipment_type_id, quantity')
          .eq('team_id', teamId)
          .eq('status', 'assigned');

        if (equipmentResult.error) throw equipmentResult.error;
        
        const equipmentAssignments: any[] = equipmentResult.data || [];
        if (equipmentAssignments.length === 0) return 0;

        const equipmentTypeIds: string[] = equipmentAssignments.map((e: any) => e.equipment_type_id);
        
        // @ts-ignore
        const typesResult = await supabase
          .from('team_equipment_types')
          .select('id, base_price')
          .in('id', equipmentTypeIds);

        if (typesResult.error) throw typesResult.error;
        
        const equipmentTypes: any[] = typesResult.data || [];

        const priceMap = new Map<string, number>();
        equipmentTypes.forEach((t: any) => priceMap.set(t.id, t.base_price));
        
        let total = 0;
        equipmentAssignments.forEach((assignment: any) => {
          const price = priceMap.get(assignment.equipment_type_id) || 0;
          total += price * assignment.quantity;
        });

        return total;
      } catch (error) {
        console.error('Error calculating team equipment total:', error);
        return 0;
      }
    },
    enabled: !!teamId,
  });
};
